import { render, staticRenderFns } from "./hotPicks.vue?vue&type=template&id=2fe91800&scoped=true"
import script from "./hotPicks.vue?vue&type=script&lang=js"
export * from "./hotPicks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe91800",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fe91800')) {
      api.createRecord('2fe91800', component.options)
    } else {
      api.reload('2fe91800', component.options)
    }
    module.hot.accept("./hotPicks.vue?vue&type=template&id=2fe91800&scoped=true", function () {
      api.rerender('2fe91800', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appNewRenovation/components/hotPicks.vue"
export default component.exports